var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddColumn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,14V2.5c0-.3.2-.5.5-.5h4c.3,0,.5.2.5.5v11.5h-1V6h-3v8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,2.5c0-.3.2-.5.5-.5h4c.3,0,.5.2.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,7.7v-1.7h-3v4c0,.3-.3.2-.5.2s-.6-.4-.6-.6V2.5c0-.3.2-.5.5-.5h4c.3,0,.5.2.5.5v5.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2,7c-2.5,0-4.5,2-4.5,4.5s2,4.5,4.5,4.5,4.5-2,4.5-4.5-2-4.5-4.5-4.5ZM13.7,12h-2v2h-1v-2h-2v-1h2v-2h1v2h2v1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.7,
    y: 2,
    width: 6,
    height: 4
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddColumn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/addColumn.63cdc091ad69dca5c5998c574777668c.svg";